import React, { FunctionComponent } from 'react'
import styles from './ObjectTitle.module.sass'
import clsx from 'clsx'
import { closedDeclination, requestedDeclination, taskDeclination } from '../../../utils/utils'
import { ObjectStatus, objectToColor, ProjectWorkObject } from '../../../responses/objects'
import { TaskStatus } from '../../../constants/enums'
import { taskStatusToColor } from '../../../responses/tasks'
import ObjectName from '../ObjectName/ObjectName'
import DesignStatusElement from '../../data-components/elements/DesignStatusElement/DesignStatusElement'
import ChevronLeftIcon from 'files/chevron/left.svg'
import FolderIcon from 'files/folder.svg'
import FolderOpenIcon from 'files/folder-open.svg'
import Button from '../../controls/Button/Button'
import SideMark from '../SideMark/SideMark'
import { inactiveContext } from '../../../constants/contexts'
import Field from '../../controls/Field/Field'
import WithData from '../../pages/projects/ProjectEdit/WithData'
import EditIcon from 'files/edit.svg'
import CopyIcon from 'files/copy.svg'
import { HasAnyPermission } from '../HasPermission'
import { PERMISSIONS } from '../../../constants/permissions'
import { useQueries } from '../../../utils/hooks/useQueries'

type Props = {
    className?: string,
    active?: boolean,
    /** reverse icon */
    arrow?: 'back' | 'none'
    object: ProjectWorkObject,
    onClick?: () => void,
    onArrowClick?: () => void,
    onTextClick?: () => void,
    markWidth?: number,
    button?: boolean,
} & ({
    editable: true,
    edit: boolean,
    onEdit: () => void,
    onDuplicate: () => void,
    onChange: (value: string) => void,
    onCancel: () => void,
} | {
    editable?: undefined
})

function objectTitleTooltip(props:any) { // eslint-disable-line
    let html = ''
    props.forEach((prop:any) => { // eslint-disable-line
        html += ` <div style=" margin-bottom: 5px;"> <div style="font-size: 11px; color: #929497">${prop.name}</div> <div style="font-size: 11px;">${prop.cost}₽ | ${prop.date_range}</div></div>`
    })

    return <div dangerouslySetInnerHTML={{ __html: html }} />

}

const ObjectTitle: FunctionComponent<Props> = props => {
    const {
        work_object_type, tasks_count, tasks_active_count, tasks_requested_count, design_status, production_status
    } = props.object
    /*const {
        work_object_type, tasks_count, tasks_active_count, tasks_requested_count
    } = props.object*/

    //console.log(work_object_type.work_object.types)
    const tasks_closed_count = tasks_count - tasks_active_count - tasks_requested_count
    const {isMobile} = useQueries()
    let tooltip:any = ''// eslint-disable-line
    if(props.button) {
        tooltip = objectTitleTooltip(work_object_type.work_object.types)
    }


    return <div
        className={clsx(props.className, styles.title, {
            [styles.interactive]: props.onClick,
            [styles.active]: props.active,
        })}
        onClick={props.onClick}
    >
        <SideMark width={props.markWidth} color={objectToColor(props.object)}/>
        <inactiveContext.Provider value={false}>
        {
            props.arrow !== 'none' && <Button className={styles.arrow} onClick={props.onArrowClick}>
                {
                    props.arrow === 'back' ?
                        <ChevronLeftIcon/>:
                        props.active?
                            <FolderOpenIcon/>:
                            <FolderIcon/>
                }
            </Button>
        }
        </inactiveContext.Provider>
        <div className={styles.type}>
           {/* <span className={styles.object}>Объект |&nbsp;</span>*/}
            <span className={styles.object}>Объект</span>
            {
                props.children ?? <>
                    {/*<span>{work_object_type.name}</span>*/}
                    {
                        props.object.status_id !== ObjectStatus.OPENED && <div className={styles.statuses}>
                            <DesignStatusElement small tooltip status={design_status} type={'design'}/>
                            <DesignStatusElement small tooltip status={production_status} type={'production'}/>
                        </div>
                    }
                </>
            }
        </div>{

    }
        {props.button ? <Button
            className={styles.left}
            title={({
                content: (<div>{tooltip}</div>)
            })}
            // onClick={props.onClear}
        >
            <ObjectName
                className={clsx(styles.name, props.object.status_id !== ObjectStatus.OPENED && styles.pl80)}
                object={props.object}
                onClick={props.onTextClick}
            >
                {
                    props.editable && props.edit && <WithData initialData={props.object.name ?? ''}>
                        {
                            ({data, setData}) => <Field
                                autoFocus
                                value={data}
                                onChange={setData}
                                onBlur={props.onCancel}
                                onEscape={props.onCancel}
                                onEnter={() => props.onChange(data)}
                            />
                        }
                    </WithData>
                }
            </ObjectName>
        </Button> : <ObjectName
            className={styles.name}
            object={props.object}
            onClick={props.onTextClick}
        >
            {
                props.editable && props.edit && <WithData initialData={props.object.name ?? ''}>
                    {
                        ({data, setData}) => <Field
                            autoFocus
                            value={data}
                            onChange={setData}
                            onBlur={props.onCancel}
                            onEscape={props.onCancel}
                            onEnter={() => props.onChange(data)}
                        />
                    }
                </WithData>
            }
        </ObjectName>
        }


        {
            props.editable && !props.edit && !isMobile && <HasAnyPermission
                permissions={[PERMISSIONS.OBJECT.CREATE, PERMISSIONS.PROJECT.EDIT]}
            >
                <div className={styles.edit}>
                    <Button
                        title={'Переименовать'}
                        onClick={event => {
                            event.stopPropagation()
                            props.onEdit()
                        }}
                    >
                        <EditIcon/>
                    </Button>
                    <Button
                        title={'Дублировать'}
                        onClick={event => {
                            event.stopPropagation()
                            props.onDuplicate()
                        }}
                    >
                        <CopyIcon/>
                    </Button>
                </div>
            </HasAnyPermission>
        }
        <div className={styles.count}>
            {
                !tasks_count ? 'Нет задач' : <>
                    <span>{taskDeclination(tasks_count).toLowerCase()} : </span>
                    {
                        tasks_requested_count > 0 &&
                        <span style={{color: taskStatusToColor(TaskStatus.REQUESTED)}}>
                        {requestedDeclination(tasks_requested_count)}
                    </span>
                    }
                    {
                        tasks_active_count > 0 && <>
                            {
                                tasks_requested_count > 0 && <span> | </span>
                            }
                            <span style={{color: taskStatusToColor(TaskStatus.OPENED)}}>
                            {tasks_active_count} в работе
                        </span>
                        </>
                    }
                    {
                        tasks_closed_count > 0 && <>
                            {
                                (tasks_requested_count > 0 || tasks_active_count > 0) && <span> | </span>
                            }
                            <span style={{color: taskStatusToColor(TaskStatus.CLOSED)}}>
                            {closedDeclination(tasks_closed_count)}
                        </span>
                        </>
                    }
                </>
            }
        </div>
    </div>
}

export default ObjectTitle
